import axios from 'axios';

const url = 'https://io.lan1.net/';

export default {
  getShop() {
    return this.customGet('v8/shop')
  },
  getShopItem(id) {
    return this.customGet('v8/item/' + id)
  },
  postStartTransaction(credentials) {
    return this.customPost('v8/start/transaction', credentials)
  },
  postCheckTransaction(credentials) {
    return this.customPost('v8/check/transaction', credentials)
  },
  postAbortTransaction(credentials) {
    return this.customPost('v8/abort/transaction', credentials)
  },
  postDownloadVoucherA4(credentials) {
    return axios({
      method: 'post',
      url: url + 'download/voucher/a4/default',
      responseType: 'arraybuffer',
      data: credentials
    }).then(response => response).catch(e => e.response)
  },
  postDownloadInvoice(credentials) {
    return axios({
      method: 'post',
      url: url + 'download/invoice',
      responseType: 'arraybuffer',
      data: credentials
    }).then(response => response).catch(e => e.response)
  },
  customGet(target) {
    return axios.get(url + target).then(response => response).catch(e => e.response);
  },
  customPost(target, credentials) {
    return axios.post(url + target, credentials).then(response => response).catch(e => e.response);
  },
  forceFileDownload(name, data) {
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', name) //or any other extension
    document.body.appendChild(link)
    link.click()
  },
};


